var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseCircleRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.314,
    height: 17.314,
    viewBox: "0 0 17.314 17.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M12.032,3.375a8.657,8.657,0,1,0,8.657,8.657A8.627,8.627,0,0,0,12.032,3.375Zm4.329,11.774-1.212,1.212-3.117-3.117L8.916,16.361,7.7,15.149l3.117-3.117L7.7,8.916,8.916,7.7l3.117,3.117L15.149,7.7l1.212,1.212-3.117,3.117Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fb3640"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/close-circle-red.8f1dc2e6dc2bbc31fa8685d997194925.svg";
export { ForwardRef as ReactComponent };